<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  bottom: { type: String, default: '12px' },
  right: { type: String, default: '26px' },
})

const isOpen = ref(false)
const unreadCount = ref(0)

const safeZE = (...args) => {
  try {
    if (typeof zE !== 'undefined') zE(...args)
  } catch (e) {}
}

const toggle = () => {
  // Optimistically toggle state so the icon switches immediately.
  // messenger:on events sync state for external closes (native X button).
  isOpen.value = !isOpen.value
  if (isOpen.value) {
    safeZE('messenger', 'open')
  } else {
    safeZE('messenger', 'close')
  }
}

onMounted(() => {
  // Sync state when user closes via the native widget X button
  safeZE('messenger:on', 'open', () => { isOpen.value = true })
  safeZE('messenger:on', 'close', () => { isOpen.value = false })
  safeZE('messenger:on', 'unreadMessages', (count) => { unreadCount.value = count })
})
</script>

<template>
  <button
    @click="toggle"
    :style="{ bottom, right }"
    class="fixed z-[9998] flex items-center justify-center w-12 h-12 rounded-full bg-tint-1 shadow-lg hover:bg-tint-2 transition-colors duration-200"
    aria-label="Open support chat"
  >
    <!-- Unread count badge -->
    <span
      v-if="!isOpen && unreadCount > 0"
      class="absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-white bg-red-500 rounded-full leading-none"
    >
      {{ unreadCount > 99 ? '99+' : unreadCount }}
    </span>

    <Icon
      v-if="isOpen"
      icon="heroicons:chevron-down"
      class="text-xl text-white"
    />
    <Icon
      v-else
      icon="heroicons:chat-bubble-left-ellipsis"
      class="text-xl text-white"
    />
  </button>
</template>
